<template>
  <div v-if="settings.name" class="home">
    <site-header :dark="isIntersecting" :inverted="isMobile" flat />
    <div class="mobile-hero-wrapper" v-if="isMobile">
      <img
        v-if="bgImage"
        :src="bgImage"
        width="100%"
        class="mobile-hero-image"
      />
      <div class="mobile-hero-content pa-2">
        <hello-world
          v-if="header"
          is-mobile
          class="mt-6"
          :title="localize('sections.header.title')"
          :subtitle="localize('sections.header.sub_title')"
        />
        <home-filters v-intersect="onIntersect" />
      </div>
    </div>
    <div v-else>
      <div ref="parallaxContainer" class="parallax-wrapper">
        <div
          v-if="bgImage"
          class="parallax-bg"
          :style="{
            backgroundImage: `url(${bgImage})`,
            transform: `translateY(${parallaxOffset}px)`,
          }"
        />
      </div>
      <div class="parallax-content">
        <span
          v-intersect="onIntersect"
          class="p-absolute"
          style="top: 20%"
          aria-hidden="true"
        />
        <v-card
          color="transparent"
          elevation="0"
          dark
          class="d-flex flex-column justify-center"
          style="height: 100%"
        >
          <hello-world
            v-if="header"
            class="mb-12"
            :title="localize('sections.header.title')"
            :subtitle="localize('sections.header.sub_title')"
          />
          <home-filters v-intersect="onIntersect" class="px-4 px-sm-12" />
        </v-card>
      </div>
    </div>
    <v-container>
      <site-listings
        :title="$t('exactly_what_you_are_looking_for')"
        class="mb-8 mt-12 mb-sm-16"
        lg="4"
        featured
      />
    </v-container>
    <home-top-destinations
      v-if="!!settings.destination_cities.length"
      :cities="settings.destination_cities"
    />
    <!-- <home-features /> -->
    <home-reviews />
    <!-- <home-trigger>
      <home-filters />
    </home-trigger> -->
    <v-divider />
    <site-footer />
    <!-- <site-bottom-navigation v-if="isMobile" /> -->
  </div>
</template>

<script>
import {
  BACKDROP,
  HOME_TITLE,
  HOME_SUBTITLE,
  HOME_LISTINGS_TITLE,
} from "@/consts/CMS";
import { mapActions, mapState } from "vuex";
import DeviceMixin from "@/mixins/device-mixin";
import MediaMixin from "@/mixins/media-mixin";
import FormattersMixin from "@/mixins/formatters-mixin";
import SiteHeader from "@/components/header/site-header";
import HelloWorld from "@/components/home/hello-world";
import HomeFilters from "@/components/home/home-filters.vue";
import SiteListings from "@/components/common/site-listings.vue";
import HomeTopDestinations from "@/components/home/home-top-destinations";
// import HomeFeatures from "@/components/home/home-features";
import HomeReviews from "@/components/home/home-reviews.vue";
// import HomeTrigger from "@/components/home/home-trigger";
import SiteFooter from "@/components/footer/site-footer";
const FALLBACK_BG =
  "https://res.cloudinary.com/do4tedxg6/image/upload/f_auto,q_auto/booking-site/generic-background_qivodb.png";
// import SiteBottomNavigation from "@/components/footer/site-bottom-navigation";

export default {
  name: "home-view",
  components: {
    SiteHeader,
    HelloWorld,
    HomeFilters,
    SiteListings,
    HomeTopDestinations,
    SiteFooter,
    HomeReviews,
    // HomeFeatures,
  },
  mixins: [DeviceMixin, MediaMixin, FormattersMixin],
  data: () => ({
    BACKDROP,
    HOME_TITLE,
    HOME_SUBTITLE,
    HOME_LISTINGS_TITLE,
    height: 0,
    isIntersecting: false,
    bottomMenuItem: "search",
    parallaxOffset: 0,
  }),
  computed: {
    screenHeight() {
      return window.innerHeight;
    },
    header() {
      return this.settings?.sections?.header;
    },
    ...mapState({
      settings: (state) => state.settingsModule.settings,
    }),
    bgImage() {
      if (!this.settings?.bg_image) return FALLBACK_BG;
      return this.isMobile
        ? this.settings.bg_image.replace(
            "upload/",
            "upload/f_auto,q_auto,c_fill,ar_1:2,h_700/"
          )
        : this.resize(this.settings.bg_image, this.screenHeight);
    },
  },
  methods: {
    onIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting;
    },
    handleScroll() {
      if (this.$refs.parallaxContainer) {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        const containerTop = this.$refs.parallaxContainer.offsetTop;
        const containerHeight = this.$refs.parallaxContainer.offsetHeight;

        if (
          scrollTop >= containerTop &&
          scrollTop <= containerTop + containerHeight
        ) {
          this.parallaxOffset = (scrollTop - containerTop) * 0.3;
        }
      }
    },
  },
  mounted() {
    window.scrollTo({ top: 0 });
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.home {
  .mobile-hero-wrapper {
    position: relative;
    min-height: 100vh;
    height: auto;
    overflow: hidden;
    background-color: rgb(0, 0, 0);
    padding-bottom: 2rem;
  }

  .mobile-hero-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
  }

  .mobile-hero-content {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .parallax-wrapper {
    position: relative;
    height: 112vh;
    overflow: hidden;
    background-color: rgb(0, 0, 0);
  }

  .parallax-bg {
    position: absolute;
    top: -30%;
    left: 0;
    width: 100%;
    height: 130%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    filter: brightness(0.6);
    will-change: transform;
  }

  .parallax-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1;
  }
}

.z-index-1 {
  position: relative;
  z-index: 1;
}
</style>
